import React from 'react';
import { createOptionsList } from '../../../services/common/miscUtils';
import { getMaxBirthDate, getMinBirthDate } from '../../../services/common/validation';
import { DatePickerFormField } from '../../Fieldset/DatePickerFormField';
import { EircodeFormField } from '../../Fieldset/EircodeFormField';
import { SelectFormField } from '../../Fieldset/SelectFormField';
import { TextInputFormField } from '../../Fieldset/TextInputFormField';
import { PersonalDetailsFormNewModel } from './formModel';
import { AddressSearchFormField } from '../../Fieldset/AddressSearchFormField';
import { CountyEnum } from '../../../types/countyEnum';
import { TitleEnum } from '../../../types/forms';

const typeSafeFormFieldName = (formFieldName: keyof PersonalDetailsFormNewModel) => formFieldName;

export const createFormInputs = (formTranslationKey: string, disableAllFormControls: boolean) => {
  return {
    title: () => (
      <SelectFormField
        fieldName={typeSafeFormFieldName('title')}
        labelTranslationKey={`${formTranslationKey}:fields:title:label`}
        optionList={createOptionsList(TitleEnum, 'personalDetailsForm', 'title')}
        isDisabled={disableAllFormControls}
      />
    ),
    firstName: () => (
      <TextInputFormField
        fieldName={typeSafeFormFieldName('firstName')}
        labelTranslationKey={`${formTranslationKey}:fields:firstName:label`}
        placeholderTranslationKey="contactDetailsForm:fields:firstName:placeholder"
        isDisabled={disableAllFormControls}
      />
    ),
    lastName: () => (
      <TextInputFormField
        fieldName={typeSafeFormFieldName('lastName')}
        labelTranslationKey={`${formTranslationKey}:fields:lastName:label`}
        placeholderTranslationKey="contactDetailsForm:fields:lastName:placeholder"
        isDisabled={disableAllFormControls}
      />
    ),
    dateOfBirth: () => (
      <DatePickerFormField
        fieldName={typeSafeFormFieldName('dateOfBirth')}
        labelTranslationKey={`${formTranslationKey}:fields:dateOfBirth:label`}
        placeholderTranslationKey="contactDetailsForm:fields:dateOfBirth:placeholder"
        maxDate={getMaxBirthDate()}
        minDate={getMinBirthDate()}
        isDisabled={disableAllFormControls}
      />
    ),
    searchAddress: () => <AddressSearchFormField />,
    addressLine1: () => (
      <TextInputFormField
        fieldName={typeSafeFormFieldName('addressLine1')}
        isDisabled={disableAllFormControls}
        labelTranslationKey={`${formTranslationKey}:fields.addressLine1.label`}
        placeholderTranslationKey={`${formTranslationKey}:fields.addressLine1.placeholder`}
      />
    ),
    addressLine2: () => (
      <TextInputFormField
        fieldName={typeSafeFormFieldName('addressLine2')}
        isDisabled={disableAllFormControls}
        labelTranslationKey={`${formTranslationKey}:fields.addressLine2.label`}
        placeholderTranslationKey={`${formTranslationKey}:fields.addressLine2.placeholder`}
      />
    ),
    addressLine3: () => (
      <TextInputFormField
        fieldName={typeSafeFormFieldName('addressLine3')}
        isDisabled={disableAllFormControls}
        labelTranslationKey={`${formTranslationKey}:fields.addressLine3.label`}
        placeholderTranslationKey={`${formTranslationKey}:fields.addressLine3.placeholder`}
      />
    ),
    eirCode: () => (
      <EircodeFormField
        fieldName={typeSafeFormFieldName('eirCode')}
        isDisabled={disableAllFormControls}
        labelTranslationKey={`${formTranslationKey}:fields.eirCode.label`}
        placeholderTranslationKey={`${formTranslationKey}:fields.eirCode.placeholder`}
      />
    ),
    town: () => (
      <TextInputFormField
        fieldName={typeSafeFormFieldName('town')}
        isDisabled={disableAllFormControls}
        labelTranslationKey={`${formTranslationKey}:fields.town.label`}
        placeholderTranslationKey={`${formTranslationKey}:fields.town.placeholder`}
      />
    ),
    county: () => (
      <SelectFormField
        fieldName={typeSafeFormFieldName('county')}
        isDisabled={disableAllFormControls}
        labelTranslationKey={`${formTranslationKey}:fields.county.label`}
        optionList={createOptionsList(CountyEnum, formTranslationKey, 'county')}
      />
    ),
  };
};
